export default {
  getOne: state => id => state.correspondencias.find(item => item.id === id),
}
